var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check",
    "data-name": "icon check",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0)",
    fill: "#daab3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M7.527,20.872l-7.2-7.244a1.119,1.119,0,0,1,0-1.576l1.567-1.576a1.1,1.1,0,0,1,1.567,0l4.852,4.88L18.7,4.9a1.1,1.1,0,0,1,1.567,0L21.838,6.48a1.119,1.119,0,0,1,0,1.576L9.094,20.873A1.1,1.1,0,0,1,7.527,20.872Z",
    transform: "translate(8.961 6.796)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheck);
export default __webpack_public_path__ + "static/media/icon check.5ad5d080fe918b755134f7d30508e391.svg";
export { ForwardRef as ReactComponent };